import { createFileRoute, redirect } from '@tanstack/react-router';
import { START_PAGE } from 'config/app';
import LoginPage from 'pages/Login';
import * as R from 'remeda';
import { bearerToken } from 'store/glue/user/selectors';
import { redirectUtility } from 'utility';

// Search params accepted by /login. `redirect` carries the path the user was
// originally trying to reach when the auth guard bounced them here.
type LoginSearch = { redirect?: string };

export const Route = createFileRoute('/login')({
  // TanStack feeds raw query params through this validator and then exposes
  // the typed result via Route.useSearch() and the `search` arg in beforeLoad.
  // Anything that isn't a string is dropped — `safeRedirect` does the
  // open-redirect / loop-back filtering at navigation time.
  validateSearch: (search: Record<string, unknown>): LoginSearch => ({
    redirect: typeof search.redirect === 'string' ? search.redirect : undefined,
  }),
  // If already authenticated, skip the login UI entirely and send the user
  // to their requested destination (or the start page as a fallback).
  beforeLoad: ({ context: { store }, search }) => {
    const token = bearerToken(store.getState());
    if (R.isDefined(token)) {
      const target =
        redirectUtility.safeRedirect(search.redirect) ?? (START_PAGE as string);
      throw redirect({ to: target, replace: true });
    }
  },
  component: LoginPage,
});
